'use client';

import { FC } from 'react';

import { useIsWebView } from '@telialt/utils/src/useIsWebView/useIsWebView';

import { ENABLE_FEATURE_ONETRUST } from './ENABLE_FEATURE_ONETRUST';

const ONETRUST_TOKEN = `8ad583cf-411f-4353-b4ac-3eec6485106b${
    process.env.HYBRIS_PUBLIC_URL === 'https://www.telia.lt' ? '' : '-test'
}`;

export const OneTrustCookieScripts: FC = () => {
    const isWebView = useIsWebView();

    return (
        ENABLE_FEATURE_ONETRUST &&
        !isWebView && (
            <>
                <script
                    type="text/javascript"
                    src={`https://cdn.cookielaw.org/consent/${ONETRUST_TOKEN}/OtAutoBlock.js`}
                />
                <script
                    src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
                    data-document-language="true"
                    type="text/javascript"
                    data-domain-script={ONETRUST_TOKEN}
                />
                <script type="text/javascript" dangerouslySetInnerHTML={{ __html: 'function OptanonWrapper() {}' }} />
            </>
        )
    );
};
